export const FUNDRAISING_ASSETS_BASE_URL = process.env.VUE_APP_FUNDRAISING_ASSETS_BASE_URL;
export const FUNDRAISING_ASSETS_DEFAULT_AVATAR = 'https://res.cloudinary.com/djyeswqkn/image/upload/v1727442611/Avatars-10_qlny76.jpg';
export const FUNDRAISING_ASSETS_DEFAULT_BANNER =
  'https://res.cloudinary.com/djyeswqkn/image/upload/v1783434023/fdb2d47a-ef2a-4030-9bf1-52e1718faa8c.png';
export type FUNDRAISING_ASSETS_IMAGE_TYPES = 'Project' | 'Avatar';
